import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=9f30ca38&"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports